module.exports = __webpack_public_path__ + "img/logo2.eaec20aa.png";